:host {
  display: block;
  @include cms-base-font;
  font-family: var(--cms-font-trade-gothic);
  width: 100%;
  margin-bottom: 1.5rem;
}

.feasibility-box {
  max-width: var(--cms-container-max-width);
  padding: 0.75rem;
  @include generateBorder('006', solid,light-grey-darker);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.feasibility-challenge,
.feasibility-work-time,
.feasibility-doer,
.feasibility-project-price {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}

.svg-wrapper {
  flex: 0 0 2.5rem;
  max-width: 2.5rem;
}

.feasibility-label,
.feasibility-value {
  flex: 0 0 33.3333%;
  max-width: 33.3333%;
}

.feasibility-value {
  text-align: right;
  font-size: 1.25rem;
  line-height: 1.1;
  font-family: var(--cms-font-badhouse);
}

.dot {
  border-radius: css-var(border-radius-20-percent);
  height: 5px;
  width: 15px;
  margin-right: 0.25rem;
  background-color: var(--cms-brand1);
  display: inline-block;
}

.blank-dot {
  border-radius: css-var(border-radius-20-percent);
  height: 5px;
  width: 15px;
  margin-right: 0.25rem;
  background-color: var(--cms-dark-grey);
  display: inline-block;
}
